module.exports = __webpack_public_path__ + "img/lsjt_lyth.21b93154.png";